module.exports = __webpack_public_path__ + "static/DockerRemove1-d62280e3ffadf581a7d5d283d2180a97.png";